<script>
  export default {
    name: "FeaturesSection",
    data() {
      return {};
    },
    props: {
      features: {
        type: Array,
      },
    },
  };
</script>

<template>
  <section>
    <div class="container">
      <div class="position-relative text-center mb-5">
        <h1 class="fw-semibold mb-2">
          Explore the Power of <br />
          Sport.Video Technology
        </h1>
        <p>
          Elevate your game with our suite of innovative features designed to <br />
          revolutionize how you create, engage and share sports content.
        </p>
      </div>
      <FeaturesSectionBox v-for="(item, index) in features" :key="`fe-${index}`" :data="item" :index="index" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import '../../sass/abstracts/_mixins.scss';

  section {
    padding: 5.5rem 0 3.75rem 0;
    background: linear-gradient(178.62deg, #F4F5F7 90.7%, rgba(244, 245, 247, 0.0110282) 98.54%, rgba(244, 245, 247, 0) 100.61%);


    @include media-breakpoint-down(md) {
      padding: 4rem 0;
    }
  };
</style>